import './Microguide.css';
export var animatedContent = '_z4mh733-3-12-1';
export var contentWrapper = '_z4mh732-3-12-1';
export var footer = '_z4mh734-3-12-1';
export var stepContainer = '_z4mh730-3-12-1';
export var visualWrapper = '_z4mh731-3-12-1';
export var wrapper = '_z4mh735-3-12-1';
export var wrapperPosition = {'bottom-left':'_z4mh736-3-12-1','top-right':'_z4mh737-3-12-1','top-left':'_z4mh738-3-12-1','bottom-right':'_z4mh739-3-12-1'};